import FormField from '@cloudscape-design/components/form-field'
import Input from '@cloudscape-design/components/input'
import SpaceBetween from '@cloudscape-design/components/space-between'
import Box from '@cloudscape-design/components/box'

interface Props {
  personaName: string
  onChange: (v: string) => void
}

export function StepPersona({ personaName, onChange }: Props) {
  return (
    <SpaceBetween size="m">
      <Box variant="p">
        Give your marketing agent a name. This name will appear in notifications,
        the agent dashboard, and in the chat interface.
      </Box>
      <FormField label="Agent name" stretch>
        <Input
          value={personaName}
          onChange={e => onChange(e.detail.value)}
          placeholder="e.g. Alex"
        />
      </FormField>
    </SpaceBetween>
  )
}
